import { FormFieldSourceOption } from "./types";

interface SourceLinkedFormField {
    system_name: string;
}

export interface FormFieldSourceUpdate {
    system_name: string;
    global_form_field_id: string | null;
    parent_form_field_id: string | null;
}

export const createFormFieldSourceUpdate = (
    formField: SourceLinkedFormField,
    selectedSource: FormFieldSourceOption | null
): FormFieldSourceUpdate => {
    return {
        system_name: selectedSource?.systemName ?? formField.system_name,
        global_form_field_id: selectedSource?.sourceType === "global" ? selectedSource.id : null,
        parent_form_field_id: selectedSource?.sourceType === "local" ? selectedSource.id : null,
    };
};
